module.exports = __webpack_public_path__ + "img/en_map.66c8a42f.png";